export default "__VITE_ASSET__D4IzL55g__"